<template>
  <div class="wrapper">
    <div :class="['btn-container', { disabled }]" @click="$emit('click', currentEl)">
      <div class="alt-btn">{{ label }}</div>
      <div class="btn-icon"><font-awesome-icon v-if="iconName" :icon="iconName" /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TolAltButton',
  props: {
    label: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentEl: this
    };
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';

.wrapper {
  display: flex;
  height: 45px;
  flex-basis: 40px;

  @media only screen and (min-width: 768px) {
    flex-basis: 200px;
  }

  .btn-container {
    position: relative;
    display: flex;
    flex: 1;
    border: 1px solid $primary-blue;
    &:hover {
      cursor: pointer;
    }
    .alt-btn {
      padding: 8px 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-size: 0.7em;
      flex-basis: 80%;
    }
    .btn-icon {
      color: green;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2em;
      flex-basis: 20%;
      svg[data-icon='file-csv'] {
        color: $primary-blue;
      }
      svg[data-icon='file-pdf'] {
        color: $secondary-red;
      }
      svg[data-icon='print'] {
        color: $mid-grey-2;
      }
    }
  }
  .btn-container.disabled {
    border-color: $row-border;
    .btn-icon {
      color: $row-border;
    }
  }
}
</style>
